import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Tooltip } from "react-bootstrap";
import * as RFSActionType from "Request-Services/constants";
import * as WorkOrderActionType from "../constants";
import * as TradeActionType from "Trades/constants";
import * as ItemActionType from "Items/constants";
import * as SubcontractorActionType from "Subcontractors/constants";
import * as LotActionType from "Lots/constants";
import * as PurchaseOrderActionType from "../../Purchase-Orders/constants";
import * as PunchListActionType from "../../Punch-List/constants";
import RFSInfo from "../Components/RFSInfo";
import ReviewRFS from "../../Request-Services/Components/ReviewRFS";
import WorkOrderFiles from "./work-order-file";
import WorkOrderComments from "../Components/WorkOrderComments";
import WorkOrderInformation from "./work-order-information";
import { print } from "../../helper/unit-helper";
import { AppSettings } from "../../constants";
import PurchasesOrdersList from "../../Purchase-Orders/Components/PurchaseOrdersList";
import Translate from "components/translate";
import PubSub from "../../services/pubsub-service";
import * as PubSubActionType from "../../services/constants";
import { EmailButton } from "../Components/EmailButton";
import EmailPopup from "../Components/EmailPopup";
import queryString from "query-string";

class WorkOrderDetail extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    WorkOrderProfile: PropTypes.object,
    ManagerStore: PropTypes.object,
    TradeList: PropTypes.any,
    ItemRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
    itemRepairList: PropTypes.any,
    SubcontractorList: PropTypes.any,
    LotList: PropTypes.any,
    WorkOrderCommentList: PropTypes.any,
    WorkOrderPrivateNotesList: PropTypes.any,
    ManagePurchaseOrders: PropTypes.any,
    HomeownerLots: PropTypes.object,
    LotProfile: PropTypes.object,
    UserProfile: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      rfsId: props.match.params.RFSID,
      workOrderId: props.match.params.WorkOrderId,
      formValue: {},
      requireFormField: [],
      showEmailInputBox: false,
      recipientEmail: [],
      popup: {
        isShowOpenPopup: false,
        isShowPendPopup: false,
        isShowResolvePopup: false,
        isShowSignoffPopup: false,
        isShowDeclinePopup: false,
        isShowOpenPendingPopup: false,
        isShowReopenPopup: false,
      },
      queryParams: { page: 1, size: 10, sort: "descending" },
    };

    this.onTogglePopup = this.onTogglePopup.bind(this);
  }

  componentDidMount() {
    // this.showLoading();
    setTimeout(() => {
      this.fetchDetailWorkOrder();
      this.fetchWorkOrderComments({ ...this.state.queryParams });

      if (
        AppSettings.clientTypeValue === "Subcontractor" ||
        AppSettings.clientTypeValue === "Builder"
      ) {
        console.log("fetch", this.props.UserProfile);
        this.fetchWorkOrderPrivateNotes({ ...this.state.queryParams });
      }
    }, 1000);

    this.fetchPOList({
      sortField: "refNo",
      sortOrder: "descending",
      WoRefNo: this.state.workOrderId,
    });
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: WorkOrderActionType.RESET_WORK_ORDER_PROFILE,
    });

    this.props.dispatch({
      type: PunchListActionType.RESET_PUNCH_LIST_ITEM,
    });
  }

  showLoading = () => {
    PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
      isHideIndicator: false,
    });
  };

  fetchDetailRfs = () => {
    this.props.dispatch({
      type: RFSActionType.GET_BY_RFS_ID_ASYNC,
      params: this.state.rfsId,
    });
  };

  fetchPOList = (data = {}) => {
    const { workOrderId, rfsId } = this.state;

    if (AppSettings.clientTypeValue === "Subcontractor") {
      this.props.dispatch({
        type: PurchaseOrderActionType.GET_SUBCONTRACTOR_PURCHASE_ORDER_LIST_ASYNC,
        params: {
          WOID: workOrderId,
          rfsId,
          data,
        },
      });
    } else {
      this.props.dispatch({
        type: PurchaseOrderActionType.GET_PURCHASE_ORDER_LIST_ASYNC,
        params: {
          WOID: workOrderId,
          rfsId,
          data,
        },
      });
    }
  };

  fetchDetailWorkOrder = () => {
    console.log("Start fetchDetailWorkOrder:", AppSettings.clientTypeValue);
    if (
      AppSettings.clientTypeValue === "Subcontractor" ||
      AppSettings.clientTypeValue === "Homeowner"
    ) {
      this.props.dispatch({
        type: WorkOrderActionType.GET_GLOBAL_WORK_ORDER_DETAIL_ASYNC,
        params: {
          WOID: this.state.workOrderId,
          RFSID: this.state.rfsId,
        },
        // callback:()=>{
        //   setTimeout(() => {
        //     this.props.dispatch({
        //       type: WorkOrderActionType.GET_LAST_RESOLVED_WORK_ORDER,
        //       params: {
        //         WOID: this.state.workOrderId,
        //       },
        //   })
        //   }, 1000);
        // },
        error: () => {
          // setTimeout(() => {
          //   this.props.dispatch({
          //     type: WorkOrderActionType.GET_GLOBAL_WORK_ORDER_DETAIL_ASYNC,
          //     params: {
          //       WOID: this.state.workOrderId,
          //       RFSID: this.state.rfsId,
          //     },
          //   });
          // }, 4000);
          window.location.reload();
        },
      });
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.GET_WORK_ORDER_DETAIL_ASYNC,
        params: {
          rfsRefNo: this.state.rfsId,
          woRefNo: this.state.workOrderId,
        },
        // callback:(data)=>{
        //   console.log('WO RFS data:', data);
        //   setTimeout(() => {
        //     this.props.dispatch({
        //       type: WorkOrderActionType.GET_LAST_RESOLVED_WORK_ORDER,
        //       params: {
        //         WOID: this.state.workOrderId,
        //       },
        //   })
        //   }, 1000);
        // },
        error: (apiResponse) => {
          var errorStr = `Not found workOrderId: ${this.state.workOrderId}`;
          if (apiResponse == errorStr) {
            this.props.dispatch({
              type: WorkOrderActionType.GET_WORK_ORDER_DETAIL_ASYNC,
              params: {
                rfsRefNo: this.state.rfsId,
                woRefNo: this.state.workOrderId,
              },
            });
          }
        },
      });
    }
  };

  fetchTrade = () => {
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.WorkOrderProfile.requestDetail
          ? this.props.WorkOrderProfile.requestDetail.lot.id
          : this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
    });
  };

  fetchItemRepair = (tradeId) => {
    this.props.dispatch({
      type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
      params: {
        id: tradeId,
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
    });
  };

  fetchProblem = (itemToRepairId) => {
    this.props.dispatch({
      type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
      params: {
        id: itemToRepairId,
        searchKey: "",
      },
    });
  };

  fetchSubcontractor = (tradeId) => {
    this.props.dispatch({
      type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
      params: {
        projectId: this.props.WorkOrderProfile.project.id,
        lotId: this.props.WorkOrderProfile.lot.id,
        tradeId: tradeId,
        param: {
          searchKey: "",
          selectedValue: "",
        },
      },
    });
  };

  fetchWorkOrderComments = (queryParams) => {
    const { workOrderId, rfsId } = this.state;

    const params = {
      take: queryParams.size,
      skip: queryParams.page - 1,
    };
    this.props.dispatch({
      type: WorkOrderActionType.GET_WORK_ORDER_COMMENTS_ASYNC,
      params: {
        workOrderId: workOrderId,
        rfsId,
        data: params,
      },
    });
  };

  fetchWorkOrderPrivateNotes = (queryParams) => {
    const { workOrderId, rfsId } = this.state;
    const params = {
      take: queryParams.size,
      skip: queryParams.page - 1,
      isPrivateNote: true,
    };

    this.props.dispatch({
      type: WorkOrderActionType.GET_WORK_ORDER_PRIVATE_NOTES_ASYNC,
      params: {
        workOrderId: workOrderId,
        rfsId,
        data: params,
      },
    });
  };

  onClickAddComment = (comment, commentAction, isPrivateNote = false) => {
    let data = { comment, isPrivateNote };

    if (commentAction) {
      data["commentAction"] = commentAction;
    }

    this.props.dispatch({
      type: WorkOrderActionType.ADD_WORK_ORDER_COMMENTS_ASYNC,
      params: {
        workOrderId: this.state.workOrderId,
        rfsId: this.state.rfsId,
        data,
      },
      callback: () => {
        if (!isPrivateNote) {
          this.fetchWorkOrderComments({
            ...this.state.queryParams,
            page: this.props.WorkOrderCommentList.totalPage,
          });
        } else {
          this.fetchWorkOrderPrivateNotes({
            ...this.state.queryParams,
            page: this.props.WorkOrderPrivateNotesList.totalPage,
          });
        }
      },
    });
  };

  onClickDeletePrivateNotes = (commentId, currentPage) => {
    this.props.dispatch({
      type: WorkOrderActionType.DELETE_WORK_ORDER_PRIVATE_NOTES_ASYNC,
      params: {
        workOrderId: this.state.workOrderId,
        rfsId: this.state.rfsId,
        id: commentId,
      },
      callback: () => {
        this.fetchWorkOrderPrivateNotes({
          ...this.state.queryParams,
          page: currentPage,
        });
      },
    });
  };

  onClickEditButton = (e) => {
    e.preventDefault();
    this.props.history.push(
      `/work-order/edit/${this.state.rfsId}/${this.state.workOrderId}`,
    );
  };

  onClickSubmitPopup = (e) => {
    e.preventDefault();
  };

  onClickSubmitOpenPend = (type, params) => {
    if (type === "open") {
      this.props.dispatch({
        type: WorkOrderActionType.OPEN_AN_AWAITING_WORK_ORDER_ASYNC,
        params: {
          refNo: this.state.workOrderId,
          data: params,
        },
      });
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.PEND_WORK_ORDER_ASYNC,
        params: {
          refNo: this.state.workOrderId,
          data: params,
        },
      });
    }

    this.onClickCancelPopup();
  };

  onClickCancelPopup = () => {
    this.setState({ popup: {} });
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
    });
    if (name === "itemRepair") {
      this.setState({
        problem: null,
      });
    }
    if (name === "trade") {
      this.setState({
        subcontractor: null,
        itemRepair: null,
        problem: null,
      });
    }
  };

  onTogglePopup = (type) => () => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const requireFormField = [];
    if (!woInformation.trade) {
      requireFormField.push("trade");
    }
    if (!woInformation.subcontractorProfile) {
      requireFormField.push("subcontractor");
    }
    if (!woInformation.itemToRepair) {
      requireFormField.push("itemRepair");
    }
    if (!woInformation.problem) {
      requireFormField.push("problem");
    }

    if (!requireFormField.length && type === "open") {
      let params = {
        tradeId: woInformation.trade.id,
        itemToRepairId: woInformation.itemToRepair.id,
        subcontractorId: woInformation.subcontractorProfile.subcontractorId,
        workOrderTypeId: woInformation.workOrderType.id,
        problemId: woInformation.problem.id,
        status: "Open",
      };
      this.onClickSubmitOpenPend(type, params);
    } else if (
      requireFormField.length === 1 &&
      requireFormField.includes("subcontractor") &&
      type === "pend"
    ) {
      let params = {
        tradeId: woInformation.trade.id,
        itemToRepairId: woInformation.itemToRepair.id,
        subcontractorId: null,
        workOrderTypeId: woInformation.workOrderType.id,
        problemId: woInformation.problem.id,
        status: "Pending",
      };
      this.onClickSubmitOpenPend(type, params);
    } else {
      switch (type) {
        case "open": {
          this.setState({
            popup: {
              isShowOpenPopup: !this.state.popup.isShowOpenPopup,
            },
            requireFormField,
          });
          break;
        }
        case "pend":
          this.setState({
            popup: {
              isShowPendPopup: !this.state.popup.isShowPendPopup,
            },
            requireFormField,
          });
          break;
        default:
          break;
      }
    }
  };

  onToggleResolvePopup = () => {
    this.setState({
      popup: {
        isShowResolvePopup: !this.state.popup.isShowResolvePopup,
      },
    });
  };

  onToggleSignoffPopup = () => {
    this.setState({
      popup: {
        isShowSignoffPopup: !this.state.popup.isShowSignoffPopup,
      },
    });
  };

  onToggleDeclinePopup = () => {
    this.setState({
      popup: {
        isShowDeclinePopup: !this.state.popup.isShowDeclinePopup,
      },
    });
  };

  onSaveResolvePopup = (lastResolvedDate) => {
    this.props.dispatch({
      type: WorkOrderActionType.RESOLVE_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.workOrderId,
        data: {
          status: "Resolved",
          lastResolvedDate: lastResolvedDate,
        },
      },
    });
    this.onToggleResolvePopup();
  };

  onSaveSignoffPopup = (
    lastResolvedDate,
    lastClosedDate,
    comment,
    signature,
  ) => {
    this.props.dispatch({
      type: WorkOrderActionType.SIGN_OFF_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.workOrderId,
        data: {
          status: "Closed",
          lastResolvedDate: lastResolvedDate,
          lastClosedDate: lastClosedDate,
          comment: comment,
          homeownerSignature: signature,
          isPrivateNote: false,
        },
      },
      callback: () => {
        if (comment) {
          this.onClickAddComment(comment, 4, false);
        }
      },
    });
    this.onToggleSignoffPopup();
  };

  onSaveDeclinePopup = (declineReason) => {
    this.props.dispatch({
      type: WorkOrderActionType.DECLINE_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.workOrderId,
        data: {
          status: "Declined",
          declinedReason: declineReason,
        },
      },
    });
    this.onToggleDeclinePopup();
  };

  onSaveOpenPendingPopup = (data) => {
    this.props.dispatch({
      type: WorkOrderActionType.OPEN_PENDING_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.workOrderId,
        data: {
          status: "Open",
          subcontractorId: data,
        },
      },
    });
    this.onToggleOpenPendingPopup();
  };

  onToggleOpenPendingPopup = () => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    if (
      woInformation.subcontractorProfile &&
      woInformation.subcontractorProfile.subcontractorId
    ) {
      this.onSaveOpenPendingPopup(
        woInformation.subcontractorProfile.subcontractorId,
      );
    } else {
      this.setState({
        popup: {
          isShowOpenPendingPopup: !this.state.popup.isShowOpenPendingPopup,
        },
      });
    }
  };

  onToggleReopenPopup = () => {
    this.setState({
      popup: {
        isShowReopenPopup: !this.state.popup.isShowReopenPopup,
      },
    });
  };

  onSaveReopenPopup = (isFromResolved, reopenReason) => {
    this.props.dispatch({
      type: WorkOrderActionType.RE_OPEN_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.workOrderId,
        isFromResolved: isFromResolved,
        data: {
          status: "Reopen",
          reopenReason: reopenReason,
        },
      },
      callback: () => {
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA,
          params: {
            RefNo: this.state.workOrderId,
            WorkOrderRefNo: this.state.rfsId,
            Status: "6",
          },
        });
      },
    });
    this.onToggleReopenPopup();
  };

  onReviewReopenWorkOrder = (type) => {
    this.props.dispatch({
      type: WorkOrderActionType.REVIEW_RE_OPEN_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.workOrderId,
        data: {
          status: type,
        },
      },
    });
  };

  printPreviewWorkOrder = () => {
    const {
      WorkOrderProfile: { builderProfile, requestDetail },
    } = this.props;
    if (AppSettings.clientTypeValue === "Homeowner") {
      const currentLot = this.props.HomeownerLots.find(
        (item) => item.lot.id === requestDetail.lot.id,
      );
      this.props.dispatch({
        type: WorkOrderActionType.PRINT_PREVIEW_HOMEOWNER_WORK_ORDER_ASYNC,
        params: {
          refNo: this.state.workOrderId,
          endpoint: currentLot.builderProfile.builderHost,
          headers: {
            key: currentLot.builderProfile.headerKey,
            value: currentLot.builderProfile.securityToken,
          },
        },
        callback: (status, content) => {
          if (status) {
            print(content);
          }
        },
      });
    } else if (AppSettings.clientTypeValue === "Subcontractor") {
      this.props.dispatch({
        type: WorkOrderActionType.PRINT_PREVIEW_SUBCONTRACTOR_WORK_ORDER_ASYNC,
        params: {
          endpoint: builderProfile.printWOEndpoint,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken,
          },
        },
        callback: (status, content) => {
          if (status) {
            print(content);
          }
        },
      });
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.PRINT_PREVIEW_WORK_ORDER_ASYNC,
        params: {
          refNo: this.state.workOrderId,
        },
        callback: (status, content) => {
          if (status) {
            print(content);
          }
        },
      });
    }
  };

  toolTip(type) {
    return (
      <Tooltip className="in tooltip-siteone">
        {
          type === "open" && <span>Send this work order to the assignee</span>
          // <span>Opening a work order will also send it to the specified subcontractor.</span>
        }
        {type === "pend" && (
          // <span>Pending a work order will not send it to the specified subcontractor (if any)</span>
          <span>
            Pending a work order will not send it to the assignee (if any)
          </span>
        )}
      </Tooltip>
    );
  }

  renderRequestHomeOwner() {
    // const { RFSProfile } = this.state;

    return (
      <div className="form-group">
        <div className="col-sm-12">
          <span className="text-danger">
            This request is generated by <Translate translateKey="homeowner" />
          </span>
        </div>
      </div>
    );
  }

  processMultiParams = (stringParams) => {
    let params = [];

    if (stringParams === ",") {
      return stringParams;
    }

    if (stringParams) {
      const parsedParams = queryString.parse(stringParams);

      Object.keys(parsedParams).map((el) => {
        params.push(queryString.parse(parsedParams[el]).value);
      });
    }
    return params.toString();
  };

  onClickOnEmailButton = () => {
    this.setState({ showEmailInputBox: true });
  };

  onCloseEmailBox = () => {
    this.setState({ showEmailInputBox: false });
  };

  objToParams = (obj) => {
    const urlParams = queryString.parse(this.props.location.search);

    if (AppSettings.clientTypeValue === "Builder") {
      return {
        searchKey:
          typeof urlParams.searchKey !== "undefined" && urlParams.searchKey,
        sortField: obj.sortField ? obj.sortField : this.state.defaultSortName,
        sortOrder: obj.sortOrder ? obj.sortOrder : this.state.defaultSortOrder,
        skip: obj.skip || 0,
        Recipients: obj.recipients || [],
        TimeZoneOffset: -new Date().getTimezoneOffset(),
        Refno: this.state.workOrderId,
      };
    }
    return {
      searchKey:
        typeof urlParams.searchKey !== "undefined" && urlParams.searchKey,
      sortField: obj.sortField ? obj.sortField : obj.sort.field,
      sortOrder: obj.sortOrder ? obj.sortOrder : obj.sort.order,
      skip: obj.skip || 0,
      Recipients: obj.recipients || [],
      TimeZoneOffset: -new Date().getTimezoneOffset(),
      Refno: this.state.workOrderId,
    };
  };
  renderBreadcrumb() {
    if (AppSettings.clientTypeValue === "Subcontractor") {
      return (
        <div>
          <div className="page-title clearfix">
            <div>
              <h2 className="pull-left">
                Work order #{this.state.workOrderId}
              </h2>
            </div>
            <div>
              <div className="text-right print-icon">
                <i
                  onClick={this.printPreviewWorkOrder}
                  className="glyphicon glyphicon-print"
                />
              </div>
            </div>
          </div>
          <ul className="breadcrumb">
            <li>
              <Link to={"/work-order-list"}>Work orders</Link>
            </li>
            <li className="breadcrumb-siteone-li">
              WO #{this.state.workOrderId}
            </li>
          </ul>
        </div>
      );
    }
    if (AppSettings.clientTypeValue === "Homeowner") {
      return (
        <div>
          <div className="page-title clearfix">
            <div>
              <h2 className="pull-left">
                Work order #{this.state.workOrderId}
              </h2>
            </div>
          </div>
          <ul className="breadcrumb">
            <li>
              <Link to={"/lots"}>
                <Translate translateKey="lot" plurals capitalize />
              </Link>
            </li>
            <li>
              <Link
                to={`/lots/${
                  this.props.WorkOrderProfile &&
                  this.props.WorkOrderProfile.requestDetail.lot.id
                }`}
              >
                Lot #
                {this.props.WorkOrderProfile &&
                  this.props.WorkOrderProfile.requestDetail.lot.name}
              </Link>
            </li>
            <li>
              <Link
                to={`/lots/${
                  this.props.WorkOrderProfile &&
                  this.props.WorkOrderProfile.requestDetail.lot.id
                }?active=request-for-service`}
              >
                Requests for service
              </Link>
            </li>
            <li>
              <Link
                to={`/request-for-services/${
                  this.props.WorkOrderProfile &&
                  this.props.WorkOrderProfile.requestDetail
                    ? this.props.WorkOrderProfile.requestDetail.refNo
                    : ""
                }`}
              >
                RFS #
                {this.props.WorkOrderProfile &&
                this.props.WorkOrderProfile.requestDetail
                  ? this.props.WorkOrderProfile.requestDetail.refNo
                  : ""}
              </Link>
            </li>
            <li className="breadcrumb-siteone-li">
              WO #{this.state.workOrderId}
            </li>
          </ul>
        </div>
      );
    }
    return (
      <div>
        <div className="page-title clearfix">
          <div>
            <h2 className="pull-left">Work order #{this.state.workOrderId}</h2>
          </div>
          <div>
            <div className="text-right">
              <Fragment>
                <EmailButton
                  onClick={this.onClickOnEmailButton}
                  overlay={false}
                  toolTipText="Send WO in Email"
                  style={{ color: "#333333", paddingRight: 30 }}
                />
                {this.state.showEmailInputBox && (
                  <EmailPopup
                    objToParams={this.objToParams}
                    onClose={this.onCloseEmailBox}
                    initRecipientEmails={this.state.recipientEmail}
                    workOrder={"WO detail"}
                  />
                )}
                <i
                  onClick={this.printPreviewWorkOrder}
                  className="glyphicon glyphicon-print print-icon"
                />
              </Fragment>
            </div>
          </div>
        </div>
        <ul className="breadcrumb">
          <li>
            <Link to={"/request-for-services"}>Requests for service</Link>
          </li>
          <li>
            <Link to={`/request-for-services/${this.state.rfsId}`}>
              RFS #{this.state.rfsId}
            </Link>
          </li>
          <li className="breadcrumb-siteone-li">
            WO #{this.state.workOrderId}
          </li>
        </ul>
      </div>
    );
  }

  renderWorkOrderFile() {
    // if (AppSettings.clientTypeValue === 'Subcontractor') {
    //   if (this.props.WorkOrderProfile && this.props.WorkOrderProfile.workOrder.woInformation && this.props.WorkOrderProfile.workOrder.woInformation.status === 1) {
    //     return <WorkOrderFiles workOrderId={this.state.workOrderId} />;
    //   }
    //   return null;
    // }
    const { workOrderId, rfsId } = this.state;

    return (
      <WorkOrderFiles
        history={this.props.history}
        workOrderId={workOrderId}
        rfsId={rfsId}
      />
    );
  }

  onToggleReviewRFS = () => {
    this.setState({ isReviewRFS: !this.state.isReviewRFS });
  };

  renderRFSInfo() {
    const { WorkOrderProfile, ManagerStore, LotProfile } = this.props;
    if (WorkOrderProfile && WorkOrderProfile.requestDetail) {
      if (this.state.isReviewRFS) {
        return (
          <ReviewRFS
            rfsId={this.state.rfsId}
            RFSInformation={
              ManagerStore.RFSProfile && ManagerStore.RFSProfile.project
                ? ManagerStore.RFSProfile
                : WorkOrderProfile.requestDetail
            }
            onToggleReviewRFS={this.onToggleReviewRFS}
            onReviewRfsSuccess={
              // setTimeout(() => {
              this.fetchDetailWorkOrder
            }
            // }, 5000)}
          />
        );
      }

      return (
        <RFSInfo
          RFSInformation={
            ManagerStore.RFSProfile && ManagerStore.RFSProfile.project
              ? ManagerStore.RFSProfile
              : WorkOrderProfile.requestDetail
          }
          location={this.props.location}
          onToggleReviewRFS={this.onToggleReviewRFS}
          history={this.props.history}
          mode="rfs"
          LotProfile={LotProfile}
          displayNote={true}
        />
      );
    }
    return null;
  }

  render() {
    if (
      this.props.WorkOrderProfile &&
      this.props.WorkOrderProfile.workOrder &&
      this.props.WorkOrderProfile.workOrder.woInformation
    ) {
      return (
        <div className="rfs-detail add-new-work-order">
          {this.renderBreadcrumb()}
          <div className="wrapper">
            {/*{this.props.ManagerStore.RFSProfile && this.props.ManagerStore.RFSProfile.project &&
              <RFSInfo RFSInformation={this.props.ManagerStore.RFSProfile} />
            }*/}

            {this.renderRFSInfo()}

            {this.props.WorkOrderProfile &&
              this.props.WorkOrderProfile.workOrder &&
              this.props.WorkOrderProfile.workOrder.woInformation && (
                <WorkOrderInformation
                  location={this.props.location}
                  history={this.props.history}
                  workOrderProfile={this.props.WorkOrderProfile}
                  rfsInformation={this.props.WorkOrderProfile.requestDetail}
                  rfsId={this.state.rfsId}
                  addComment={this.onClickAddComment}
                  workOrderId={this.state.workOrderId}
                  comments={this.props.WorkOrderCommentList}
                />
              )}
            {this.renderWorkOrderFile()}
            {AppSettings.clientTypeValue !== "Homeowner" &&
              AppSettings.clientTypeValue !== "Subcontractor" && (
                <PurchasesOrdersList
                  ManagePurchaseOrders={this.props.ManagePurchaseOrders}
                  WorkOrderProfile={this.props.WorkOrderProfile}
                  rfsId={this.state.rfsId}
                  workOrderId={this.state.workOrderId}
                  fetchPOList={this.fetchPOList}
                />
              )}
            <WorkOrderComments
              comments={this.props.WorkOrderCommentList}
              privateNotes={this.props.WorkOrderPrivateNotesList}
              userProfile={this.props.UserProfile}
              addComment={this.onClickAddComment}
              fetchWorkOrderComments={this.fetchWorkOrderComments}
              fetchWorkOrderPrivateNotes={this.fetchWorkOrderPrivateNotes}
              onClickDeletePrivateNotes={this.onClickDeletePrivateNotes}
              WorkOrderProfile={this.props.WorkOrderProfile}
            />
          </div>
          <iframe
            id="ifmcontentstoprint"
            style={{ height: 0, border: "none" }}
          />
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    ManagerStore: state.RFSStore,
    WorkOrderProfile: state.WorkOrderReducer.WorkOrderProfile,
    LotList: state.ProjectStore.LotList,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    TradeList: state.LotStore.TradeList,
    ItemRepairList: state.TradeStore.ItemRepairList,
    ProblemList: state.ItemRepairStore.ProblemList,
    WorkOrderCommentList: state.WorkOrderReducer.WorkOrderCommentList,
    WorkOrderPrivateNotesList: state.WorkOrderReducer.WorkOrderPrivateNotesList,
    ManagePurchaseOrders: state.PurchaseOrderStore.ManagePurchaseOrder,
    HomeownerLots: state.LotStore.HomeownerLots,
    LotProfile: state.LotStore.LotProfile,
    UserProfile: state.UserStore.UserProfile,
  };
};

export default connect(mapStateToProps)(WorkOrderDetail);



// WEBPACK FOOTER //
// ./src/Work-Orders/Containers/work-order-detail.js